import React from "react";
import CRUDDetailPage from "../../../../shared/components/crud/CRUDDetailPage";
import { vaccineRecordConfig } from "../config/vaccineRecordConfig";
import { RecordService } from "../../../../shared/services/recordService";

/**
 * VaccineRecordDetail - URL-based detail page for Vaccine Record
 * Handles view, edit, and add modes with ID from URL params
 */
export default function VaccineRecordDetail() {
  return <CRUDDetailPage config={vaccineRecordConfig} service={RecordService} />;
}
